import { QrScanner as QrReader } from '@yudiel/react-qr-scanner';
import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Button } from '@/components/Button';
import { Typography } from '@/components/Typography';
import { px2rem } from '@/theme';

import { Divider } from '../Divider/Divider';

export const QrReaderBox = styled(Box)`
  position: relative;
  svg {
    top: 100px !important;
    position: absolute;
    left: 0 !important;
    right: 0 !important;
    margin: 0 auto !important;
    width: 288px !important;
    height: 288px !important;

    border: 0 solid rgba(0, 0, 0, 0.1) !important;
    path {
      stroke-width: 1;
      stroke: rgba(255, 255, 255, 1);
    }
  }
  ${({ theme }) => css`
    height: 100%;
    ${theme.mediaQueries.sm} {
      height: auto;
    }
  `}
`;
export const QrDivider = styled(Divider)`
  margin: ${({ theme }) => theme.spacing(4, 0)};
  background: #;
`;

export const Text = styled(Typography)`
  position: absolute;
  font-size: ${px2rem(14)};
  text-align: center;
  width: 100%;
  top: 50px;
  color: ${({ theme }) => theme.colors.white};
  z-index: 100;
`;

export const QrBox = styled(Box)`
  width: 288px !important;
  position: absolute;
  left: 0 !important;
  right: 0 !important;
  margin: 0 auto !important;
  bottom: 50px;
`;

export const ButtonBox = styled(Button)`
  margin-top: ${({ theme }) => theme.spacing(4)};
`;

export const QrReaderWrapper = styled(QrReader)`
  & div {
    height: 100%;
  }
`;
